import { render, staticRenderFns } from "./resumeDelivery.vue?vue&type=template&id=03b4b01c&scoped=true&"
import script from "./resumeDelivery.vue?vue&type=script&lang=js&"
export * from "./resumeDelivery.vue?vue&type=script&lang=js&"
import style0 from "./resumeDelivery.vue?vue&type=style&index=0&id=03b4b01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b4b01c",
  null
  
)

export default component.exports